<div class="modal-header">
  <button type="button" class="close" ng-click="cancel()">&times;</button>
  <h3 class="modal-title">Configurações</h3>
</div>
<div class="modal-body">
  <form name="form">
    <div class="form-group">
      <label for="widget-title" class="control-label">Título</label>
      <input type="text" class="form-control" name="widgetTitle" ng-model="result.title">
    </div>
    <div class="form-group">
      <label class="control-label">Propriedade</label>
      <ui-select ng-model="result.dataModelOptions.propriedade" theme="bootstrap" id="propriedade" name="propriedade" append-to-body="true">
        <ui-select-match placeholder="Propriedade atual ({{$root.currentPropriedade.descricao}})">
          {{$select.selected.descricao | capitalize}}
          <span class="clear-btn" ng-click="$event.stopPropagation(); result.dataModelOptions.propriedade = null"><i class="fa fa-remove true-clear-icon"></i></span>
        </ui-select-match>
        <ui-select-choices repeat="propriedade in result.data.propriedades | orderBy: 'descricao' | filter: $select.search track by propriedade.id">
          <span class="form-group" ng-bind-html="propriedade.descricao | capitalize | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="cancel()">Cancelar</button>
  <button type="button" class="btn btn-primary" ng-click="ok()">OK</button>
</div>
